module.exports = __webpack_public_path__ + "media/bootstrap-icons/filter-circle-178a4a02.svg";